export default class Color {
  static Black = new Color(0, 'black');
  static White = new Color(1, 'white');

  constructor(public value: number, private titleRes: string) {}

  getTitleRes = () => this.titleRes;

  static fromString = (str: string) => (str === 'W' || str === 'WHITE' ? Color.White : Color.Black);

  toString = (): 'WHITE' | 'BLACK' => (this.value === 0 ? 'BLACK' : 'WHITE');

  static reverseColor = (color: Color) => (color === Color.Black ? Color.White : Color.Black);
}
